import { CloseOutlined } from '@ant-design/icons';
import { holidayApi } from 'Api/masters/holiday';
import { Col, Modal, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import Buttons from 'components/Global/Buttons';
import DatePickerField from 'components/Global/DatePicker';
import InputField from 'components/Global/InputField';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import {
	formatToDateOnly,
	hasFormError,
	toastText,
	validateFormData,
} from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { AddHolidayManuallyProps } from './types';

const AddHolidayManuallyModal: React.FC<AddHolidayManuallyProps> = (props) => {
	const { handleCancel, isAddHolidayManuallyModalOpen, edit, fetchHoliday } =
		props;

	const [manualHolidayDetails, setManualHolidayDetails] = useState<any>({
		holidayDate: dayjs(new Date().setDate(new Date().getDate() + 1)),
		holidayName: null,
	});
	const [formError, setFormError] = useState<any>({
		holidayDate: false,
		holidayName: false,
	});
	const [addManualHolidayLoading, setAddManualHolidayLoading] =
		useState<boolean>(false);
	const myButtons = [
		{
			text: 'Cancel',
			disabled: addManualHolidayLoading,
			className: 'secondary-button',
			isLoading: false,
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			isSubmit: false,
			onclick: () => {
				closeModal();
			},
		},
		{
			text: 'Save',
			isLoading: addManualHolidayLoading,
			className: 'btn-blue',
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			disabled: false,
			isSubmit: true,
			onclick: handleSubmit,
		},
	];

	const handleChange = (
		value: string | number | null,
		name: string,
		required: boolean,
		regex?: RegExp | null
	) => {
	
		if (name === 'holidayDate') {
			setManualHolidayDetails((prev: any) => {
				return {
					...prev,
					holidayDate: value,
				};
			});
		}
		if (name === 'holidayName') {
			setManualHolidayDetails((prev: any) => {
				return {
					...prev,
					holidayName: value,
				};
			});
		}
	};

	const closeModal = () => {
		setManualHolidayDetails({
			holidayDate: dayjs(new Date().setDate(new Date().getDate() + 1)),
			holidayName: null,
		});
		setFormError({
			holidayDate: false,
			holidayName: false,
		});
		handleCancel();
	};

	async function handleSubmit() {
		let checkFormError = validateFormData(
			{ ...manualHolidayDetails },
			{ ...formError }
		);

		setFormError(checkFormError);

		if (hasFormError(checkFormError)) {
			return;
		}
		const data = {
			holidayDate: formatToDateOnly(manualHolidayDetails.holidayDate),
			holidayName: manualHolidayDetails.holidayName,
		};

		setAddManualHolidayLoading(true);

		try {
			let response;
			if (edit) {
				response = await holidayApi.updateHoliday(edit.id, data);
			} else {
				response = await holidayApi.createHolidayManually(data);
			}

			fetchHoliday();
			let message =
				response?.data?.message ||
				(edit
					? 'Holiday Updated successfully'
					: 'Holiday Added successfully');
			toastText(message, 'success');
			closeModal();
		} catch (error: any) {
			let message =
				error.response?.data?.message ||
				(edit
					? 'Something went wrong in updating Holiday'
					: 'Something went wrong in creating Holiday');
			toastText(message, 'error');
		} finally {
			setAddManualHolidayLoading(false);
		}
	}

	useEffect(() => {
		if (edit) {
			setManualHolidayDetails({
				holidayDate: dayjs(edit?.holidayDate),
				holidayName: edit?.holidayName,
			});
			setFormError({
				holidayDate: false,
				holidayName: false,
			});
		}
	}, [edit]);
	return (
		<Modal
			open={isAddHolidayManuallyModalOpen}
			closable={false}
			maskClosable={true}
			onCancel={closeModal}
			width={600}
			onOk={handleSubmit}
			className="holidayManualModal"
			footer={<Buttons buttons={myButtons} />}
		>
			{' '}
			<div className={styles['modal-header']}>
				<Title level={4}>{edit ? 'Edit Holiday' : 'Add Holiday'}</Title>
				<div className={styles['right-align-items']}>
					<div className={styles['close-icon']} onClick={closeModal}>
						<CloseOutlined />
					</div>
				</div>
			</div>
			<p className={styles['form-container-head-warning']}>
				<b>
					{' '}
					<sup>*</sup>
				</b>{' '}
				Indicated mandatory fields
			</p>
			<Row gutter={16}>
				<Col span={24} className={`${styles['col']} margin-top-10`}>
					<DatePickerField
						name="holidayDate"
						value={manualHolidayDetails.holidayDate}
						label="Date "
						required={true}
						helperText="Please select a Holiday Date"
						isError={formError.holidayDate}
						onChange={(value) =>
							handleChange(value, 'holidayDate', true)
						}
					/>
				</Col>
				<Col span={24} className={`${styles['col']} margin-top-10`}>
					<InputField
						name="holidayName"
						label="Holiday Name"
						required={true}
						helperText="Please enter the Holiday Name"
						value={manualHolidayDetails.holidayName}
						disabled={false}
						isError={formError.holidayName}
						onChange={(value) =>
							handleChange(value, 'holidayName', true)
						}
					/>
				</Col>
			</Row>
		</Modal>
	);
};

export default AddHolidayManuallyModal;
